// extracted by mini-css-extract-plugin
export default {"root":"Header_root__ChPiT","title":"Header_title__oLVIS","close":"Header_close__V4ZRM","back":"Header_back__gRGEA","ask":"Header_ask__kcCqH","check":"Header_check__9KJ6n"};